import { DateTime } from 'luxon';

// There is no way to pass a timezone into @rehookify/datepicker, meaning
// $date will always be in the local timezone. To work around this, we
// represent $date in the target timezone without converting the actual time.
//
// E.g. If the user selects Jan 1 14:00 in London, the date will be converted
// to Jan 1 14:00 in New York instead of the equivalent moment in time.
export function normalizeDatePickerDate(date: Date, timezone: string): DateTime {
  return DateTime.fromJSDate(date).setZone(timezone, { keepLocalTime: true }).startOf('day');
}

export function normalizeDateTime(date: DateTime, timezone: string): DateTime {
  return date.setZone(timezone).startOf('day');
}
